export { default as DetailsModal } from './details-modal';
